/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React from 'react';
import "../../CSS/DataModal.css";
import FullLoader from "../Loader/FullLoader";
import PropTypes from "prop-types";

function CommonModal(props) {
    const { show, loading, title, content, onYes, onClick, isFullScreen = false } = props;

    const onCancelClick = () => {

    }

    let loader = loading ?
        <FullLoader/>
        : <div>{null}</div>

    let modalContent = !show ?
        <div>{null}</div>
        : <div>
            <div className={isFullScreen ? "fullscreen-modal" : "modal"} style={{ display: show ? "block" : "none" }}>
                <div className={isFullScreen ? "big-modal-wrapper" : "modal-wrapper"}
                     style={{
                         transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                         opacity: show ? '1' : '0'
                     }}>

                    <div className="modal-header">
                        <h3>{title}</h3>
                        <span className="close-modal-btn" onClick={e => { onClick(e); onCancelClick(); }}>×</span>
                    </div>

                    <div className="modal-body">
                        {content}
                    </div>


                    <div className="modal-footer">
                        <button className="secondary-btn btn-small" onClick={e => { onClick(e); onCancelClick(); }}>Cancel</button>
                        <button className="primary-btn btn-small" onClick={onYes}>Continue</button>
                    </div>
                    {loader}

                </div>

            </div>
        </div>;

    return (
        <div>{modalContent}</div>
    )
}

CommonModal.propTypes = {
    show: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    onYes: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.any.isRequired,
    isFullScreen: PropTypes.bool
};
export default CommonModal;